import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSimilarArticlesSucceed, EGetSimilarArticlesActionType } from './types';
import { IGetJournalMoreDataSchema } from '../../../repositories/journal/entities/journal/GetJournalMoreDataSchema';

export const getSimilarArticlesSucceed: (articles: IGetJournalMoreDataSchema[]) => TGetSimilarArticlesSucceed =
  actionGenerator<EGetSimilarArticlesActionType.Succeed, IGetJournalMoreDataSchema[]>(
    EGetSimilarArticlesActionType.Succeed,
  );
